module.exports = __webpack_public_path__ + "static/arbershabani-a0879e61cee57f2d67334d0d3eec5c14.jpeg";